import axios from './api';

export default async function surveyResubmit(params) {
    return await axios({
        headers: { 
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
        method: 'post',
        url: "/product/resubmitSurvey",
        params: {
            walletTrxId: params.trxId,
            comment: params.comment,
        }
    })
    .then((res) => {
      if (res.status === 200) {
        return res.status;
      }
    })
    .catch((res) => {
      throw new Error(res.response.data.message);
    })
}